const convertStatusApproveOrder = (status: number) => {
  switch (status) {
    case 0:
      return 'Mới tạo';
    case 1:
      return 'Chờ duyệt';
    case 2:
      return 'Đã duyệt';
    case 3:
      return 'Từ chối';
    case 4:
      return '-';
  }
};
export default convertStatusApproveOrder;
